module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/core-js/object/define-property.js
// module id = 580
// module chunks = 0